import React from 'react';
import {
  Descriptions,
} from 'UI';
import { ProductionItem } from 'constants/interface';
import { buildRegularProductDisplay, buildOrderItemProductDisplay } from 'helpers/order';
import { ProductTypeMapping } from 'constants/product';
import { OrderTypeDisplayMapping, OrderTypeEnum } from 'constants/order';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { ROUTES } from 'constants/routes';

import {
  OrderDescriptions,
  ActionButton,
  TextHighlight,
} from './style';

interface SummaryProps {
  item: ProductionItem
}

const Summary = ({
  item,
}: SummaryProps): JSX.Element => {
  const breadcrumb = useBreadcrumbNavigation();
  const { name: clientName } = item?.orderItem.order.client || {};
  return (
    <OrderDescriptions
      bordered
      title="Informações do Pedido"
      layout="horizontal"
    >
      {/* <Descriptions.Item> */}
      <Descriptions.Item
        label="Cliente"
      >
        {clientName}
      </Descriptions.Item>
      <Descriptions.Item
        label="Localização"
      >
        {item.orderItem.order.location?.name || '-'}
      </Descriptions.Item>
      <Descriptions.Item
        label="Encarregado"
      >
        {item.orderItem.order.location?.maintainer || '-'}
      </Descriptions.Item>
      <Descriptions.Item
        // label="Nº Pedido"
        label={(
          <ActionButton
            onClick={() => {
              const currentCrumbs = breadcrumb.current();
              breadcrumb.replace([{
                label: 'Pedidos',
                url: ROUTES.orders.root,
              }, {
                label: `Pedido Nº ${item.orderItem.order.seq}`,
                url: `${ROUTES.orders.root}/${item.orderItem.order.id}`,
              }], currentCrumbs.length);
            }}
          >
            Pedido
          </ActionButton>
        )}
      >
        {item.orderItem.order.seq}
      </Descriptions.Item>
      <Descriptions.Item
        label="Formação"
        span={2}
      >
        {OrderTypeDisplayMapping[item.orderItem.order.type].name}
      </Descriptions.Item>
      <Descriptions.Item
        label="Ordem de produção"
        span={3}
      >
        {/* {buildGraftingProductsDisplay(item.orderItem)} */}
        {buildOrderItemProductDisplay(item.orderItem)}
      </Descriptions.Item>
      {
      item.orderItem.order.type === OrderTypeEnum.GRAFTING
        ? item.orderItem.productionItems.map((relatedProdItem) => {
          const label = relatedProdItem.id !== item.id ? (
            <ActionButton
              onClick={() => {
                const currentCrumbs = breadcrumb.current();
                breadcrumb.replace([{
                  label: 'Pedidos',
                  url: ROUTES.orders.root,
                }, {
                  label: `Pedido Nº ${item.orderItem.order.seq}`,
                  url: `${ROUTES.orders.root}/${item.orderItem.order.id}`,
                }, {
                  label: `${relatedProdItem.product.variety.culture.name} ${relatedProdItem.product.variety.name}`,
                  url: `${ROUTES.orders.root}${ROUTES.orders.items.root}/${relatedProdItem.id}`,
                }], currentCrumbs.length);
              }}
            >
              {ProductTypeMapping[relatedProdItem.type]}
            </ActionButton>
          ) : (
            <TextHighlight>
              {ProductTypeMapping[relatedProdItem.type]}
            </TextHighlight>
          );
          return (
            <Descriptions.Item
              key={relatedProdItem.id}
              label={label}
              span={2}
            >
              {buildRegularProductDisplay({
                ...relatedProdItem,
                orderItem: item.orderItem,
              })}
            </Descriptions.Item>
          );
        })
        : null
      }
      <Descriptions.Item
        label="Observação da ordem de produção"
        span={3}
      >
        {item.orderItem.notes || '-'}
      </Descriptions.Item>
      <Descriptions.Item
        label="Observação do pedido"
        span={3}
      >
        {item.orderItem.order.notes || '-'}
      </Descriptions.Item>
    </OrderDescriptions>
  );
};

export default Summary;
